'use client'

import { useState } from 'react'
import dynamic from 'next/dynamic'
import Image from 'next/image'
import { Grid } from '@mui/material'

// Types
import type { SliderProps } from '@/types/components/organisms/slider'

// Helpers
import { useTranslation } from '@/helpers/i18n/client'

// Components
const ModalFormOrganism = dynamic(() => import('@/components/organisms/forms/modal'))
const SlideshowMolecule = dynamic(() => import('@/components/molecules/sliders/slideshow'))
const FeedbackButtonAtom = dynamic(() => import('@/components/atoms/buttons/feedback'))
const DividerHeaderShapeAtom = dynamic(() => import('@/components/atoms/shapes/divider-header'))

const SliderOrganism = (props: SliderProps) => {
	// Props
	const { lng, title, items, image, patternInvisible, patternPosition, patternColor, form, children } = props

	// Variables
	const { t } = useTranslation(lng)
	const [openForm, setOpenForm] = useState<boolean>(false)

	return (
		<Grid
			display="inline-flex"
			size={12}
			position="relative"
			overflow="hidden"
			sx={{
				'& > img': {
					width: 1,
					height: 'auto',
					maxHeight: { xs: 'calc(80dvh - 48px)', sm: 'calc(80dvh - 64px)', lg: 'calc(80dvh - 80px)', xl: 'calc(80dvh - 100px)' },
					filter: 'grayscale(100%)',
					objectFit: 'cover',
					objectPosition: 'top center'
				}
			}}
		>
			{!patternInvisible && (
				<Grid display="inline-flex" width={1} position="absolute" left={0} zIndex={1} sx={{ ...(patternPosition === 'bottom' ? { bottom: 0 } : { top: 0 }) }}>
					<DividerHeaderShapeAtom color={patternColor} />
				</Grid>
			)}

			{items && <SlideshowMolecule lng={lng} items={items} />}
			{image && <Image src={image} alt={t(title)} width={1440} height={814} />}

			{form && <FeedbackButtonAtom lng={lng} title="form:button.feedback" onClick={() => setOpenForm(!openForm)} />}
			{form && <ModalFormOrganism lng={lng} form={form} open={openForm} setOpen={setOpenForm} />}

			{children}
		</Grid>
	)
}

export default SliderOrganism
